import { MutationTree, Mutation } from 'vuex';
import { IState, IPage } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setPageOpenMutation: MutationHandler<{ id: string, open: boolean }> = (state, { payload }) => {
	state.pages.forEach(page => {
		if(page.id === payload.id) {
			page.open = payload.open
		}
	})
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setPageOpen: setPageOpenMutation
}

export default mutations;
